<script>
    import SiteHeader from './SiteHeader'
    import Login from '$modals/Login'
    import ProSelect from '$common/ProSelect'

    export default {
        name: 'Index',
        components: {
            SiteHeader,
            Login,
            ProSelect
        },
        data() {
            return {
                mykey: 'bar',
                locations: ["a", "b"],
                hoverEdu: false,
                hoverIndustry: false,
                showLogin: false
            }
        },
        methods: {
          dismissModal(){
            console.log("got it.  turning off")
            this.showLogin = false
          }
        }
        
    }
</script>

<template lang="pug">
    .foo
        site-header
        .awaiting
          .awaiting-text 
            h3 Awaiting Approval
            p Thanks for your registration! Your application will be reviewed by administrators; when it is approved, you will receive an email invitation to log in.

</template>

<style lang="sass" scoped>
@import '$vars'

.awaiting
  background-color: #EEEEEE
  height: 100vh
  text-align: center

.awaiting-text
  font-size: 1.5em
  padding: 50px
  width: 50%
  margin: 0 auto

.box-text
    font-size: 2em

.foo
    background-color: white

.spacer
    height: 50px

#educ_btn:hover
    background-color: white
    color: #chamber-orange

#industry_btn:hover
    background-color: white
    color: #33404f

#educ_div
  background-color: #chamber-orange

#industry_div
  background-color: #33404f

.invisible
    opacity: 0%

.visible
    opacity: 100% !important

.holder_div
  color: #fff;
  padding: 0 !important;
  height: 90vh;
  min-height: 500px !important;
  text-align: center;
  transition: .3s;
  position: relative;


.hover_div
  text-align: left;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 50;
  opacity: 0;
  transition: .5s;

.hover_div
    h3
        margin-top: 15vh;
        padding: 0;
        padding-bottom: .5em;
        text-align: left;
        color: #fff !important;


.hover_div
    p
        text-align: left
        margin: 4em 4em 2em 4em;
        color: #fff;
        padding-bottom: 2em;
        font-size: 16px;


.default_div
  padding-top: 15em;
  position: absolute;
  height: 100%;
  width: 100%;
  transition: .5s;


#educ_default 
  background-image: url("~@/assets/1_educatorportal.jpg");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;


#industry_default 
  background-image: url("~@/assets/2_industryportal.jpg");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;


.hover_div 
    h3
        padding-top: 1.5em;


.button
  border: 1px solid #fff;
  color: #fff;
  padding: .75em 4em .75em 4em;



// BOXES //

.boxes
  padding: 0 !important;
  color: white;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;


#box1
  height: 26.25vw;
  background-image: url("~@/assets/4.jpg");


#box2
  height: 26.25vw;
  background-color: #008aad;
  vertical-align: middle;

#box3, #box3_s 
  height: 26.25vw;
  background-image: url("~@/assets/5.jpg");

#box4
  height: 26.25vw;
  background-color: $chamber-orange
  vertical-align: middle;

#box5
  background-color: $chamber-orange
  height: 26.253vw;
  background-image: url("~@/assets/3.jpg");

#box6
  height: 26.25vw;
  background-color: #33404f
  vertical-align: middle;

</style>